/* LumosClock Homepage v2 — Boutique edition interactions
   (Claude Design export, 2026-07-14)
   Scope: scroll-reveal, FAQ accordion, sticky mobile buy-bar, language dropdown,
   live word clock (SVG-versie uit de Claude Design export — exact dezelfde
   opbouw/uitlijning als het ontwerp, i.p.v. het oudere foto-based component). */
(function () {
  'use strict';

  /* Live word clock — Hero (dynamic, volgt de echte tijd; EN + IT) */
  (function () {
    var root = document.querySelector('[data-live-word-clock-hero]');
    if (!root) return;
    var grid = root.querySelector('[data-clock-grid]');
    if (!grid) return;
    var locale = (root.getAttribute('data-locale') || 'en').slice(0, 2);

    var EN_HOURS = ['TWELVE', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE_H', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN_H', 'ELEVEN'];
    var IT_HOURS = ['DODICI', 'UNA', 'DUE', 'TRE', 'QUATTRO', 'CINQUE_H', 'SEI', 'SETTE', 'OTTO', 'NOVE', 'DIECI_H', 'UNDICI'];
    var ES_HOURS = ['DOCE', 'UNA', 'DOS', 'TRES', 'CUATRO', 'CINCO_H', 'SEIS', 'SIETE', 'OCHO', 'NUEVE', 'DIEZ_H', 'ONCE'];

    /* Elke cel heeft precies een data-w; woorden die letters delen zijn in
       het raster opgesplitst (zie snippets/lc-homepage-clock-grid.liquid).
       Daarom geen uitzonderingen meer per taal. */
    function setWord(word, on) {
      var nodes = grid.querySelectorAll('[data-w="' + word + '"]');
      for (var j = 0; j < nodes.length; j++) nodes[j].classList.toggle('on', on);
    }
    function clearAll() {
      var lit = grid.querySelectorAll('[data-w].on');
      for (var j = 0; j < lit.length; j++) lit[j].classList.remove('on');
    }

    function renderEN() {
      var now = new Date();
      var h = now.getHours(), m = now.getMinutes();
      var block = Math.floor(m / 5), dots = m % 5;
      var cur = h % 12, disp = block >= 7 ? (cur + 1) % 12 : cur;
      clearAll();
      var words = ['ITS'];
      switch (block) {
        case 0: words.push(EN_HOURS[disp], 'OCLOCK'); break;
        case 1: words.push('FIVE_M', 'MINUTES', 'PAST', EN_HOURS[disp]); break;
        case 2: words.push('TEN_M', 'MINUTES', 'PAST', EN_HOURS[disp]); break;
        case 3: words.push('A', 'QUARTER', 'PAST', EN_HOURS[disp]); break;
        case 4: words.push('TWENTY', 'MINUTES', 'PAST', EN_HOURS[disp]); break;
        case 5: words.push('TWENTY', 'FIVE_M', 'MINUTES', 'PAST', EN_HOURS[disp]); break;
        case 6: words.push('HALF', 'PAST', EN_HOURS[disp]); break;
        case 7: words.push('TWENTY', 'FIVE_M', 'MINUTES', 'TO', EN_HOURS[disp]); break;
        case 8: words.push('TWENTY', 'MINUTES', 'TO', EN_HOURS[disp]); break;
        case 9: words.push('A', 'QUARTER', 'TO', EN_HOURS[disp]); break;
        case 10: words.push('TEN_M', 'MINUTES', 'TO', EN_HOURS[disp]); break;
        case 11: words.push('FIVE_M', 'MINUTES', 'TO', EN_HOURS[disp]); break;
      }
      for (var k = 0; k < words.length; k++) setWord(words[k], true);
      var dotSpans = root.querySelectorAll('[data-dot]');
      for (var d = 0; d < dotSpans.length; d++) dotSpans[d].classList.toggle('on', d < dots);
    }

    /* Italiaans, plaatversie 2: tot en met :35 met E (":35" = E TRENTACINQUE),
       vanaf :40 MENO + het volgende uur. Het omslagpunt ligt dus bij blok 8,
       niet bij blok 7 zoals op de vorige plaat. */
    function renderIT() {
      var now = new Date();
      var h = now.getHours(), m = now.getMinutes();
      var block = Math.floor(m / 5), dots = m % 5;
      var cur = h % 12;
      var disp = block >= 8 ? (cur + 1) % 12 : cur;
      clearAll();
      var words = [];
      if (disp === 1) {
        words.push('E_ACC', 'L_UNA', 'UNA');
      } else {
        words.push('SONO', 'LE', IT_HOURS[disp]);
      }
      var MENO = ['MENO_M', 'E_CON', 'MENO_NO'];
      switch (block) {
        case 0: break;
        case 1: words.push('E_CON', 'CINQUE_M'); break;
        case 2: words.push('E_CON', 'DIECI_M'); break;
        case 3: words.push('E_CON', 'UN', 'QUARTO'); break;
        case 4: words.push('E_CON', 'VENTI'); break;
        case 5: words.push('E_CON', 'VENTI', 'CINQUE_M'); break;
        case 6: words.push('E_CON', 'MEZZA'); break;
        case 7: words.push('E_CON', 'TRENTA', 'CINQUE_M'); break;
        case 8: words = words.concat(MENO, ['VENTI']); break;
        case 9: words = words.concat(MENO, ['UN', 'QUARTO']); break;
        case 10: words = words.concat(MENO, ['DIECI_M']); break;
        case 11: words = words.concat(MENO, ['CINQUE_M']); break;
      }
      for (var k = 0; k < words.length; k++) setWord(words[k], true);
      var dotSpans = root.querySelectorAll('[data-dot]');
      for (var d = 0; d < dotSpans.length; d++) dotSpans[d].classList.toggle('on', d < dots);
    }

    /* Spaans: "ES LA UNA" voor 1 uur, anders "SON LAS <uur>". Tot en met
       :30 met Y, vanaf :35 MENOS + het volgende uur. De overlappende
       woorden staan als losse stukjes in het raster (zie
       snippets/lc-homepage-clock-grid.liquid), daarom ES_E/ES_S/SON_ON
       en VEINTI + CINCO_M. */
    function renderES() {
      var now = new Date();
      var h = now.getHours(), m = now.getMinutes();
      var block = Math.floor(m / 5), dots = m % 5;
      var cur = h % 12;
      var disp = block >= 7 ? (cur + 1) % 12 : cur;
      clearAll();
      var words = [];
      if (disp === 1) {
        words.push('ES_E', 'ES_S', 'LA');
      } else {
        words.push('ES_S', 'SON_ON', 'LA', 'LAS_S');
      }
      words.push(ES_HOURS[disp]);
      switch (block) {
        case 0: break;
        case 1: words.push('Y', 'CINCO_M'); break;
        case 2: words.push('Y', 'DIEZ_M'); break;
        case 3: words.push('Y', 'CUARTO'); break;
        case 4: words.push('Y', 'VEINTE'); break;
        case 5: words.push('Y', 'VEINTI', 'CINCO_M'); break;
        case 6: words.push('Y', 'MEDIA'); break;
        case 7: words.push('MENOS', 'VEINTI', 'CINCO_M'); break;
        case 8: words.push('MENOS', 'VEINTE'); break;
        case 9: words.push('MENOS', 'CUARTO'); break;
        case 10: words.push('MENOS', 'DIEZ_M'); break;
        case 11: words.push('MENOS', 'CINCO_M'); break;
      }
      for (var k = 0; k < words.length; k++) setWord(words[k], true);
      var dotSpans = root.querySelectorAll('[data-dot]');
      for (var d = 0; d < dotSpans.length; d++) dotSpans[d].classList.toggle('on', d < dots);
    }

    var RENDERERS = { en: renderEN, it: renderIT, es: renderES };
    var render = RENDERERS[locale] || renderEN;
    render();
    setInterval(render, 1000);
  })();

  /* Videos pas laden wanneer hun sectie in de buurt komt.

     Audit 22-9-2026 (P1): de twee homepagevideo's stonden op autoplay en
     waren samen goed voor ~3.825 KiB — ongeveer 70% van alles wat de
     homepage ophaalde — terwijl ze allebei ver onder de eerste scherminhoud
     staan. preload="none" alleen hielp niet: autoplay zet de download toch
     meteen in gang. Daarom staat de bron in data-src en hangen we hem hier
     pas in het element.

     rootMargin 600px: ruim voordat het kader in beeld komt, zodat de
     overgang van poster naar bewegend beeld niet opvalt.

     Bij databesparing starten we niets vanzelf, maar verschijnt er een
     startknop op de poster. Hetzelfde gebeurt als de browser autoplay
     weigert.

     "Reduce motion" gaf die knop eerst ook. Dat pakte verkeerd uit: op een
     gewone Windows-pc met animatie-effecten uit stonden alle video's stil,
     terwijl de bedoeling was om beweging te beperken die de aandacht opeist
     — niet om de inhoud weg te nemen. Deze video's zijn stil, klein in beeld
     en loopen rustig, dus ze starten nu ook daar vanzelf. */
  (function () {
    var vids = document.querySelectorAll('video[data-lc-video]');
    if (!vids.length) return;

    var manual = !!(navigator.connection && navigator.connection.saveData);

    function button(v) {
      var frame = v.parentElement;
      return frame ? frame.querySelector('.lc-video-play') : null;
    }

    function showButton(v) {
      var b = button(v);
      if (b) b.hidden = false;
    }

    // play() kan afgewezen worden (strengere autoplay-regels, of doordat de
    // gebruiker nog niets heeft aangeraakt). Dan blijft de poster staan met
    // de startknop erop, in plaats van een zwart kader.
    //
    // Eén uitzondering: een play() die meteen na het zetten van de bron
    // wordt gestart, breekt de browser zelf af zodra het laden begint —
    // AbortError. Dat is geen weigering, dus daar hoort geen knop bij; we
    // proberen het gewoon opnieuw zodra er genoeg in huis is. Hierdoor
    // bleven de video's eerder staan met een startknop erop terwijl autoplay
    // gewoon toegestaan was.
    function attempt(v) {
      var p = v.play();
      if (!p || !p.then) return;
      p.then(function () {
        var b = button(v);
        if (b) b.hidden = true;
      }, function (err) {
        if (err && err.name === 'AbortError') return;
        showButton(v);
      });
    }

    function load(v) {
      if (v.getAttribute('src')) { attempt(v); return; }
      var src = v.getAttribute('data-src');
      if (!src) return;
      v.addEventListener('canplay', function () { attempt(v); }, { once: true });
      // Geen load(): het zetten van src start het laden al, en een load()
      // ertussen is juist wat de eerste play() afbreekt.
      v.setAttribute('src', src);
      attempt(v);
    }

    Array.prototype.forEach.call(vids, function (v) {
      var b = button(v);
      if (!b) return;
      b.addEventListener('click', function () {
        b.hidden = true;
        load(v);
      });
    });

    if (manual) {
      Array.prototype.forEach.call(vids, showButton);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      // Zonder observer niet alles ineens ophalen: pas bij de eerste scroll.
      window.addEventListener('scroll', function once() {
        window.removeEventListener('scroll', once);
        Array.prototype.forEach.call(vids, load);
      }, { passive: true, once: true });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        load(e.target);
      });
    }, { rootMargin: '600px 0px' });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  })();

  /* Scroll reveal */
  (function () {
    var els = document.querySelectorAll('.rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* Smooth "floating" in-page scroll for anchor links (hero CTAs, footer,
     FAQ/personalise/story links, etc.) — replaces the native anchor jump
     with an eased, slower scroll for a more weightless feel. */
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Bij "reduce motion" niet volledig uitschakelen (dat gaf een harde sprong,
    // omdat de browser ook CSS scroll-behavior:smooth negeert) — maar een korte,
    // rustige scroll gebruiken i.p.v. de volle glide.
    var DURATION = reduceMotion ? 450 : 1100;

    function easeOutQuint(t) { return 1 - Math.pow(1 - t, 5); }

    function smoothScrollTo(target, duration) {
      var startY = window.scrollY;
      var targetY = target.getBoundingClientRect().top + startY;
      var diff = targetY - startY;
      var start;
      function step(ts) {
        if (start === undefined) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        window.scrollTo(0, startY + diff * easeOutQuint(progress));
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;
      var target = document.getElementById(hash.slice(1));
      if (!target) return;
      e.preventDefault();
      smoothScrollTo(target, DURATION);
      if (history.pushState) history.pushState(null, '', hash);
    });
  })();

  /* FAQ — smooth accordion, one open at a time */
  (function () {
    var faqItems = document.querySelectorAll('.faq-list .faq-item');
    var DURATION = 320;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function closeItem(item) {
      var answer = item.querySelector('.answer');
      if (!answer) return;
      answer.style.height = '';
      answer.style.opacity = '';
      answer.style.transition = '';
      item.removeAttribute('open');
    }

    function openItem(item) {
      var answer = item.querySelector('.answer');
      if (!answer || item._animating) return;
      item.setAttribute('open', '');
      if (reduceMotion) return;
      item._animating = true;
      answer.style.height = '0px';
      answer.style.opacity = '0';
      answer.style.transition = 'none';
      var endH = answer.scrollHeight;
      requestAnimationFrame(function () {
        answer.style.transition = 'height ' + DURATION + 'ms ease, opacity ' + DURATION + 'ms ease';
        answer.style.height = endH + 'px';
        answer.style.opacity = '1';
        var onEnd = function (e) {
          if (e.propertyName !== 'height') return;
          answer.removeEventListener('transitionend', onEnd);
          answer.style.height = '';
          answer.style.transition = '';
          item._animating = false;
        };
        answer.addEventListener('transitionend', onEnd);
      });
    }

    faqItems.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item._animating) return;
        if (item.open) {
          closeItem(item);
        } else {
          faqItems.forEach(function (other) {
            if (other !== item && other.open) closeItem(other);
          });
          openItem(item);
        }
      });
    });
  })();

  /* Sticky-buy show on scroll past hero */
  (function () {
    var sticky = document.getElementById('sticky-buy');
    var hero = document.getElementById('top');
    if (!sticky || !hero) return;
    window.addEventListener('scroll', function () {
      var below = (window.scrollY > (hero.offsetTop + hero.offsetHeight - 200));
      sticky.classList.toggle('visible', below);
    });
  })();

  /* Language dropdown */
  (function () {
    var wrap = document.querySelector('.lang-switch');
    if (!wrap) return;
    var trigger = wrap.querySelector('.lang-trigger');
    if (!trigger) return;
    function close() { wrap.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false'); }
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = wrap.classList.toggle('open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

})();
